export const MIN_NAME_LENGTH = 3;
export const MIN_PASSWORD_LENGTH = 8;

export const MFA_CODE_REGEX = RegExp(/^[0-9]{6}$/);

export const EMAIL_REGEX = RegExp(/^[_a-z0-9-]+(\.[_a-z0-9-]+)*(\+[a-z0-9-]+)?@[a-z0-9-]+(\.[a-z0-9-]+)*$/i);

// Comma or semi-colon separated with optional whitespace around delimiter
export const MULTIPLE_EMAIL_REGEX = RegExp(
  /^(([_a-z0-9-]+(\.[_a-z0-9-]+)*(\+[a-z0-9-]+)?@[a-z0-9-]+(\.[a-z0-9-]+)*)([;,]\s*))*([_a-z0-9-]+(\.[_a-z0-9-]+)*(\+[a-z0-9-]+)?@[a-z0-9-]+(\.[a-z0-9-]+)*)$/i,
);

export const INTEGER_REGEX = RegExp(/^\d+$/);

export const SIGNED_INTEGER_REGEX = RegExp(/^[+-]?\d+$/);

export const COMPANY_NUMBER_REGEX = RegExp(/^[0-9a-zA-Z]{1,8}$/);

export const COMPANY_AUTH_CODE_REGEX = RegExp(/^[a-zA-Z0-9]{6}$/);

export const COMPANY_HOUSE_PERSONAL_CODE_REGEX = RegExp(/^[a-zA-Z0-9]{11}$/);

export const WEBSITE_REGEX = RegExp(/^([a-z0-9-]+\.)+[a-z]{2,}(\/[^\s]*)?$/i);

export const DATE_OFFSET_REGEX = RegExp(/^([+-]{1}[0-9]+[dbwmystunez]{1})+$/);

export const DATE_OFFSET_SPLIT_REGEX = RegExp(/([+-]{1}[0-9]+[dbwmystunez]{1})/g);

export const ISO_DATE_REGEX = RegExp(/^\d{4}-\d{2}-\d{2}$/);

export const UK_DATE_REGEX = RegExp(/^\d{2}\/\d{2}\/\d{4}$/);

export const UK_DATE_SHORT_YEAR_REGEX = RegExp(/^\d{2}\/\d{2}\/\d{2}$/);

export const isValidEmail = (value: string | null | undefined) => {
  return value ? EMAIL_REGEX.test(value) : false;
};

export const isValidMultipleEmail = (value: string | null | undefined) => {
  return value ? MULTIPLE_EMAIL_REGEX.test(value) : false;
};

export const isValidInteger = (value: string | null | undefined) => {
  return value ? INTEGER_REGEX.test(value) : false;
};

export const isValidSignedInteger = (value: string | null | undefined) => {
  return value ? SIGNED_INTEGER_REGEX.test(value) : false;
};

export const isValidCompanyNumber = (value: string | null | undefined) => {
  return value ? COMPANY_NUMBER_REGEX.test(value) : false;
};

export const isValidWebsite = (value: string | null | undefined) => {
  return value ? WEBSITE_REGEX.test(value) : false;
};

export const isValidIsoDate = (value: string | null | undefined) => {
  return value ? ISO_DATE_REGEX.test(value) : false;
};

export const isValidUkDate = (value: string | null | undefined) => {
  return value ? UK_DATE_REGEX.test(value) : false;
};
